import { ActionReducer, Action } from '@ngrx/store';
import { FlightReducerInitState } from '../models/flight-reducer.interface';

export const UPDATE_FLIGHT_REQUEST = 'UPDATE_FLIGHT_REQUEST';
export const UPDATE_FLIGHT_RESPONSE = 'UPDATE_FLIGHT_RESPONSE';
export const UPDATE_FINAL_DESTINATION = 'UPDATE_FINAL_DESTINATION';
export const UPDATE_MANUAL_DESTINATION = 'UPDATE_MANUAL_DESTINATION';
export const REFRESH_FLIGHT_STATE = 'REFRESH_FLIGHT_STATE';
export const UPDATE_FLIGHT_PRODUCTS = 'UPDATE_FLIGHT_PRODUCTS';
export const UPDATE_FLIGHT_LANDED = 'UPDATE_FLIGHT_LANDED';
export const RESET_FLIGHT_STATE = 'RESET_FLIGHT_STATE';

export interface ActionWithPayloadInterface extends Action {
  payload: any;
}

const initState: FlightReducerInitState = {
  flightDetails: {
    flightRequest: {},
    flightResponse: {},
    flightFinalDestination: {airportCode: '', airportName: '', airportCityName: '', airportCountryName: ''},
    flightManualDestination: {},
    flightProducts: {
      abc: false,
      ccd: false,
      sds: false,
      isDomesticABC: false
    },
    flightLanded : false
  }
};

export function flightReducer (state: FlightReducerInitState = initState, action: ActionWithPayloadInterface) {

  switch (action.type) {

    case UPDATE_FLIGHT_REQUEST:
      return Object.assign({}, state, { flightDetails: Object.assign({}, state.flightDetails, { flightRequest: action.payload })});

    case UPDATE_FLIGHT_RESPONSE:
      return Object.assign({}, state, { flightDetails: Object.assign({}, state.flightDetails, { flightResponse: action.payload })});

    case UPDATE_FINAL_DESTINATION:
      return Object.assign({}, state, { flightDetails: Object.assign({}, state.flightDetails, { flightFinalDestination: action.payload })});

    case UPDATE_MANUAL_DESTINATION:
      return Object.assign({}, state,
        { flightDetails: Object.assign({}, state.flightDetails, { flightManualDestination: action.payload })});

    case UPDATE_FLIGHT_PRODUCTS:
      return Object.assign({}, state, { flightDetails: Object.assign({}, state.flightDetails, { flightProducts: action.payload })});

    case UPDATE_FLIGHT_LANDED:
      return Object.assign({}, state, { flightDetails: Object.assign({}, state.flightDetails, { flightLanded: action.payload })});

    case REFRESH_FLIGHT_STATE:
      state = Object.assign({}, action.payload);
      return state;

    case RESET_FLIGHT_STATE:
      state = Object.assign({}, initState);
      return state;

    default:
      return state;

  }

};
